import { render, staticRenderFns } from "./collectCustomInfo.vue?vue&type=template&id=de1afa9a&scoped=true&lang=html&"
import script from "./collectCustomInfo.vue?vue&type=script&lang=js&"
export * from "./collectCustomInfo.vue?vue&type=script&lang=js&"
import style0 from "./collectCustomInfo.vue?vue&type=style&index=0&id=de1afa9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de1afa9a",
  null
  
)

export default component.exports